import { columns } from "./columns";
import { Heading } from "../../ui/heading";
import { Separator } from "../../ui/separator";
import { News } from "@/src/data/types";
import { DataTable } from "../../ui/data-table";
import { Button } from "../../ui/button";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface NewsProps {
  data: News[];
}

export const NewsData: React.FC<NewsProps> = ({ data }) => {
  const router = useNavigate();
  return (
    <>
      <div className="flex items-start justify-between">
        <Heading
          title={`Actualités (${data.length})`}
          description="Liste des actualités "
        />

        <Button
          className="text-xs md:text-sm"
          onClick={() => router(`/admin-dashboard/actualité/ajouter`)}
        >
          <Plus className="w-4 h-4 mr-2" /> Ajouter
        </Button>
      </div>
      <Separator />
      <DataTable searchKey="title" columns={columns} data={data} />
    </>
  );
};
